module.exports = __webpack_public_path__ + "static/img/my.61ef810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my.png
// module id = 4Ysc
// module chunks = 1